<template>
	<div class="session-wrapper">
		<div class="session-left">
			<!-- <slick :options="slickOptions"></slick> -->
		</div>
		<v-container fluid>
			<v-layout row wrap justify-center>
				<v-flex xs12 md6 lg4>
					<div class="session-table-cell text-center">
						<div class="session-content">
							<img 
								:src="appLogo"
								class="img-responsive mb-3" 
								width="78" 
								height="78" 
							/>
							<h2 class="mb-3">{{$t('message.loginToAdmin')}}</h2>
							<p class="fs-14">{{$t('message.enterUsernameAndPasswordToAccessControlPanelOf')}} {{brand}}.</p>
							<v-form v-model="valid" class="mb-4">
								<v-text-field 
									label="Tên đăng nhập" 
									v-model="username" 
									required
								></v-text-field>
								<v-text-field 
									label="Mật khẩu" 
									v-model="password" 
									type="password" 
									:rules="passwordRules" 
									required
								></v-text-field>
								<v-checkbox 
									color="primary" 
									label="Ghi nhớ tài khoản" 
									v-model="is_remember_user"
								></v-checkbox>
								<!-- <router-link class="mb-1" to="/session/forgot-password">{{$t('message.forgotPassword')}}?</router-link> -->
								<div>
									<v-btn large @click="submit" block color="primary">{{$t('message.loginNow')}}</v-btn>
								</div>
							</v-form>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AppConfig from "Constants/AppConfig";
// import Slick from "vue-slick";

export default {
  components: {
    // Slick
  },
  data() {
    return {
      valid: false,
      username: "",
      // usernameRules: [
      //   v => !!v || "E-mail is required",
      //   v =>
      //     /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      //     "E-mail must be valid"
      // ],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      appLogo: AppConfig.appLogo2,
	  brand: AppConfig.brand,
	  is_remember_user: true,
    };
	},
	computed: {
		slickOptions() {
      return {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        rtl: this.$store.getters.rtlLayout
      };
    }
	},
  methods: {
    submit() {
      	const user = {
			username: this.username,
			password: this.password,
			is_remember_user: this.is_remember_user
		};
		this.$store.dispatch( 'signIn', user )
    },
  }
};
</script>